import { C } from '../../theme.js';
import { Alert, Code, Eyebrow } from '../../components/Primitives.jsx';
import { MultiColsDropdown } from './MultiColsDropdown.jsx';
import { hasUpstreamSplit } from '../../data.js';
import { DecimalPlacesField } from '../shared/DecimalPlacesField.jsx';
import { OutputColumnNamesField } from '../shared/OutputColumnNamesField.jsx';

/**
 * StandardScalingInspector
 * Formula: z = (x - μ) / σ  (zero mean, unit variance / Z-score normalization)
 */
export function StandardScalingInspector({ step, onChange, pipeline }) {
  const c = step.config || {};
  const sel = Array.isArray(c.columns) ? c.columns : (c.column ? [c.column] : []);
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  const splitReady = pipeline ? hasUpstreamSplit(pipeline.steps, step.id) : true;
  return (
    <div>
      <Eyebrow>Standard scaling (Z-score)</Eyebrow>
      <div style={{ color: C.fg4, fontSize: '.78rem', margin: '4px 0 10px', lineHeight: 1.5 }}>
        Standardize features by removing the mean and scaling to unit variance: z = (x - μ) / σ.
        Each selected column is kept; a new <Code>{'<col>_method_scaled'}</Code> column is added.
      </div>
      {!splitReady && (
        <Alert kind="warn" style={{ marginBottom: 10 }}>
          No Train / Test Split step found upstream — this will fit using all rows. If the result feeds a model, add a Train / Test Split step first to avoid data leakage.
        </Alert>
      )}
      <MultiColsDropdown selected={sel} onChange={(v) => u({ columns: v, column: v[0] || null })} numeric />
      <OutputColumnNamesField
        columns={sel}
        value={c.output_columns}
        onChange={(v) => u({ output_columns: v })}
        legacyValue={c.output_column}
        autoName={(col) => `${col}_standard_scaled`}
      />
      <DecimalPlacesField value={c.output_decimals} onChange={(v) => u({ output_decimals: v })} />
    </div>
  );
}
